import { cn } from "@/lib/cn";

export type RecipeVersionOut = {
  version_no: number;
  notes: string | null;
  is_auto_saved: boolean;
  committed_at: string;
};

interface VersionPickerProps {
  versions: RecipeVersionOut[];
  from: number | null;
  to: number | null;
  onFromChange: (v: number) => void;
  onToChange: (v: number) => void;
}

export function VersionPicker({
  versions,
  from,
  to,
  onFromChange,
  onToChange,
}: VersionPickerProps) {
  return (
    <div className="space-y-2">
      <div
        className={cn(
          "grid gap-2",
          "border border-zinc-300 dark:border-zinc-700 rounded",
          "bg-white dark:bg-zinc-950",
          "p-3",
        )}
        style={{ gridTemplateColumns: "auto 1fr auto auto" }}
      >
        {/* Header */}
        <div className="font-semibold text-xs text-zinc-600 dark:text-zinc-400">Version</div>
        <div className="font-semibold text-xs text-zinc-600 dark:text-zinc-400">Notes / Date</div>
        <div className="font-semibold text-xs text-zinc-600 dark:text-zinc-400">From</div>
        <div className="font-semibold text-xs text-zinc-600 dark:text-zinc-400">To</div>

        {/* Rows */}
        {versions.map((version) => {
          const noteText = version.is_auto_saved ? "auto-saved" : version.notes || "—";
          const dateStr = new Date(version.committed_at).toLocaleDateString();

          return [
            <div
              key={`${version.version_no}-label`}
              className="font-mono text-sm text-zinc-900 dark:text-zinc-100"
            >
              v{version.version_no}
            </div>,
            <div
              key={`${version.version_no}-notes`}
              className="text-sm text-zinc-700 dark:text-zinc-300"
            >
              {noteText} · {dateStr}
            </div>,
            <div key={`${version.version_no}-from`} className="flex items-center justify-center">
              <input
                type="radio"
                name="diff-from"
                checked={from === version.version_no}
                onChange={() => onFromChange(version.version_no)}
                className="cursor-pointer"
                aria-label={`From version ${version.version_no}`}
              />
            </div>,
            <div key={`${version.version_no}-to`} className="flex items-center justify-center">
              <input
                type="radio"
                name="diff-to"
                checked={to === version.version_no}
                onChange={() => onToChange(version.version_no)}
                className="cursor-pointer"
                aria-label={`To version ${version.version_no}`}
              />
            </div>,
          ];
        })}
      </div>
    </div>
  );
}
